import { TipoDocumento, ChecklistItem } from '../types';

/**
 * Aplica as regras de negócio para formatação de documentos
 * baseado no tipo de documento e nome do titular
 */
export class DocumentFormatter {
  static formatarDocumento(tipo: TipoDocumento, nomeTitular: string): string {
    if (!nomeTitular.trim()) {
      return '';
    }

    switch (tipo) {
      case 'Acta de Nascimento Espanhola emitida pelo Ministério da Justiça Espanhol':
        return `${tipo} de ${nomeTitular}, via digital`;
      
      case 'Certidão Negativa de Naturalização':
        return `${tipo} de ${nomeTitular}, com apostille na via digital`;
      
      case 'Anexo I':
      case 'Anexo III':
        return `${tipo}, (3 vias preenchida e 1 via em branco)`;
      
      case 'Datos Nacimientos':
      case 'Solicitud de Inscripción como residente':
        return `${tipo}, (2 vias preenchidas e 1 via em branco)`;
      
      default:
        return `${tipo} de ${nomeTitular}, com apostille na via original`;
    }
  }

  static gerarChecklist(itens: ChecklistItem[]): string[] {
    return itens
      .filter(item => item.nomeTitular.trim() !== '')
      .map(item => this.formatarDocumento(item.tipo, item.nomeTitular));
  }
}
